import { render, staticRenderFns } from "./btn-primary2.vue?vue&type=template&id=e03174fa&scoped=true&"
import script from "./btn-primary2.vue?vue&type=script&lang=js&"
export * from "./btn-primary2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03174fa",
  null
  
)

export default component.exports